<template>
    <div class = "mainContainer">
        <div class = "selectItemsContainer">
            <div class = "textContainer" @click="togglePlan()">
                <p v-if = "showAggressive" class = "plan-text-inside">Income Aggressive</p>
                <p v-else class = "plan-text-inside">Income Conservative</p>
                <v-icon class="material-icons-round">
                    arrow_drop_down
                </v-icon>
            </div>
        </div>
        <div class = "activeInvestments mt-5">
          <allActiveInvestment
            :currentTabItem = "currentTabItem"
          />
        </div>
  </div>
</template>
<script>
import allActiveInvestment from '@/components/dashboard/allActiveinvestment.vue'
export default {
    components: {
        allActiveInvestment
    },
    props: {
        selectedItem: String
    },
    data () {
        return {
            currentTabItem: null,
            showAggressive: null
        }
    },
    watch: {
        selectedItem: function (newVal, oldVal) {
            this.currentTabItem = newVal
        }
    },
    mounted () {
        this.currentTabItem = this.selectedItem
        if (this.selectedItem === 'incomeAggressive') {
            this.showAggressive = true
        } else {
            this.showAggressive = false
        }
    },
    methods: {
        togglePlan () {
            this.showAggressive = !this.showAggressive
            if (this.showAggressive === true) {
                this.currentTabItem = 'incomeAggressive'
            } else {
                this.currentTabItem = 'incomeConservative'
            }
        }
    }
}
</script>

<style>

    .selectItemsContainer {
        display: none;
        width: 70%;
    }

    .activeInvestments {
        width: 73%;
    }

    .addFunds {
        color: #002fa7 !important;
    }

    .addFundsContainer {
        display: flex;
        width: -webkit-fill-available;
        justify-content: flex-end;
    }

    .mainContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .textContainer {
        display: flex;
        flex-direction: row;
    }

    .plan-text-inside {
        width: max-content;
        font-weight: 600;
        font-size: 17px;
        color: #232323;
        margin-bottom: 0px !important;
    }

    @media (max-width: 1000px) {
        .selectBar {
            display: flex;
            min-width: 224px;
        }

        .selectItemsContainer {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }

    @media (max-width:768px) {
        .selectItemsContainer {
            width: 70% !important;
        }
        .activeInvestments {
            width: 70% !important;
        }
    }

    @media (max-width:480px) {
        .selectItemsContainer {
            width: 100% !important;
        }
        .activeInvestments {
            width: 100% !important;
        }
    }

</style>
